<div class="container">
  <mat-card>
    <div class="layout-row responsive-column gap-20px">
      <div class="flex-50">
        <mat-nav-list>
          <div #office>
            <mat-list-item *LOSxHasPermission="'READ_OFFICE'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['offices']">
                  <mat-icon matListIcon>
                    <fa-icon icon="building" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Manage Offices' | translate }}
                    @if (arrowBooleans[0]) {
                      <p matLine [routerLink]="['offices']" class="menu-explanation">
                        {{ 'labels.text.Add new office or modify or deactivate office' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[0]) {
                    <fa-icon (click)="arrowBooleansToggle(0)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[0]) {
                    <fa-icon (click)="arrowBooleansToggle(0)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #holidays>
            <mat-list-item *LOSxHasPermission="'READ_HOLIDAY'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['holidays']">
                  <mat-icon matListIcon>
                    <fa-icon icon="calendar-alt" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Manage Holidays' | translate }}
                    @if (arrowBooleans[1]) {
                      <p matLine [routerLink]="['holidays']" class="menu-explanation">
                        {{ 'labels.text.Define holidays for office' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[1]) {
                    <fa-icon (click)="arrowBooleansToggle(1)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[1]) {
                    <fa-icon (click)="arrowBooleansToggle(1)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #employee>
            <mat-list-item *LOSxHasPermission="'READ_STAFF'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['employees']">
                  <mat-icon matListIcon>
                    <fa-icon icon="user" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Manage Employees' | translate }}
                    @if (arrowBooleans[2]) {
                      <p matLine [routerLink]="['employees']" class="menu-explanation">
                        {{ 'labels.text.Employee represents loan officers' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[2]) {
                    <fa-icon (click)="arrowBooleansToggle(2)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[2]) {
                    <fa-icon (click)="arrowBooleansToggle(2)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #standinginstructions>
            <mat-list-item *LOSxHasPermission="'READ_STANDINGINSTRUCTION'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['standing-instructions-history']">
                  <mat-icon matListIcon>
                    <fa-icon icon="book" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Standing Instructions History' | translate }}
                    @if (arrowBooleans[3]) {
                      <p matLine [routerLink]="['standing-instructions-history']" class="menu-explanation">
                        {{ 'labels.text.View logged history' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[3]) {
                    <fa-icon (click)="arrowBooleansToggle(3)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[3]) {
                    <fa-icon (click)="arrowBooleansToggle(3)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #investor>
            <mat-list-item *LOSxHasPermission="'READ_OFFICE'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['investors']">
                  <mat-icon>
                    <fa-icon icon="user-tie" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.text.Investors' | translate }}
                    @if (arrowBooleans[4]) {
                      <p matLine [routerLink]="['investors']" class="menu-explanation">
                        {{ 'labels.text.View the loan account details associated with the investors' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[4]) {
                    <fa-icon (click)="arrowBooleansToggle(4)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[4]) {
                    <fa-icon (click)="arrowBooleansToggle(4)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #fundmapping>
            <mat-list-item *LOSxHasPermission="'READ_OFFICE'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['fund-mapping']">
                  <mat-icon matListIcon>
                    <fa-icon icon="money-bill-alt" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Fund Mapping' | translate }}
                    @if (arrowBooleans[5]) {
                      <p matLine [routerLink]="['fund-mapping']" class="menu-explanation">
                        {{ 'labels.text.Bulk entry screen for mapping' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[5]) {
                    <fa-icon (click)="arrowBooleansToggle(5)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[5]) {
                    <fa-icon (click)="arrowBooleansToggle(5)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #passwordpreferences>
            <mat-list-item *LOSxHasPermission="'READ_PASSWORD_VALIDATION_POLICY'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['password-preferences']">
                  <mat-icon>
                    <fa-icon icon="lock" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Password Preferences' | translate }}
                    @if (arrowBooleans[6]) {
                      <p matLine [routerLink]="['password-preferences']" class="menu-explanation">
                        {{ 'labels.text.The usage of stronger passwords' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[6]) {
                    <fa-icon (click)="arrowBooleansToggle(6)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[6]) {
                    <fa-icon (click)="arrowBooleansToggle(6)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #provisioning>
            <mat-list-item *LOSxHasPermission="'VIEW_PROVISIONS'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['provisioning-criteria']">
                  <mat-icon matListIcon>
                    <fa-icon icon="edit" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Loan Provisioning Criteria' | translate }}
                    @if (arrowBooleans[7]) {
                      <p matLine [routerLink]="['provisioning-criteria']" class="menu-explanation">
                        {{ 'labels.text.Loan Provisioning Criteria Organization' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[7]) {
                    <fa-icon (click)="arrowBooleansToggle(7)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[7]) {
                    <fa-icon (click)="arrowBooleansToggle(7)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #entitydatatable>
            <mat-list-item *LOSxHasPermission="'READ_ENTITY_DATATABLE_CHECK'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['entity-data-table-checks']">
                  <mat-icon matListIcon>
                    <fa-icon icon="check" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Entity Data Table Checks' | translate }}
                    @if (arrowBooleans[8]) {
                      <p matLine [routerLink]="['entity-data-table-checks']" class="menu-explanation">
                        {{ 'labels.text.Entity Data Table Checks Organization' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[8]) {
                    <fa-icon (click)="arrowBooleansToggle(8)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[8]) {
                    <fa-icon (click)="arrowBooleansToggle(8)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>
        </mat-nav-list>
      </div>

      <div class="flex-50">
        <mat-nav-list>
          <div #addEditCurrency>
            <mat-list-item *LOSxHasPermission="'READ_CURRENCY'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['currencies']">
                  <mat-icon matListIcon>
                    <fa-icon icon="cogs" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Currency Configuration' | translate }}
                    @if (arrowBooleans[9]) {
                      <p matLine [routerLink]="['currencies']" class="menu-explanation">
                        {{ 'labels.text.Currencies available across organization' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[9]) {
                    <fa-icon (click)="arrowBooleansToggle(9)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[9]) {
                    <fa-icon (click)="arrowBooleansToggle(9)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #manageFunds>
            <mat-list-item *LOSxHasPermission="'READ_FUND'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['manage-funds']">
                  <mat-icon matListIcon>
                    <fa-icon icon="money-bill-alt" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Manage Funds' | translate }}
                    @if (arrowBooleans[10]) {
                      <p matLine [routerLink]="['manage-funds']" class="menu-explanation">
                        {{ 'labels.text.Funds are associated with loans' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[10]) {
                    <fa-icon (click)="arrowBooleansToggle(10)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[10]) {
                    <fa-icon (click)="arrowBooleansToggle(10)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #bulkloan>
            <mat-list-item *LOSxHasPermission="'BULKREASSIGN_LOAN'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['bulkloan']">
                  <mat-icon>
                    <fa-icon icon="money-bill-alt" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Bulk Loan Reassignment' | translate }}
                    @if (arrowBooleans[11]) {
                      <p matLine [routerLink]="['bulkloan']" class="menu-explanation">
                        {{ 'labels.text.Easy way to reassign all the loan' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[11]) {
                    <fa-icon (click)="arrowBooleansToggle(11)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[11]) {
                    <fa-icon (click)="arrowBooleansToggle(11)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #tellers>
            <mat-list-item *LOSxHasPermission="'READ_TELLER'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['tellers']">
                  <mat-icon>
                    <fa-icon icon="money-bill-alt" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Teller / Cashier Management' | translate }}
                    @if (arrowBooleans[12]) {
                      <p matLine [routerLink]="['tellers']" class="menu-explanation">
                        {{ 'labels.text.Manage Tellers / Cashiers' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[12]) {
                    <fa-icon (click)="arrowBooleansToggle(12)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[12]) {
                    <fa-icon (click)="arrowBooleansToggle(12)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #workingDays>
            <mat-list-item *LOSxHasPermission="'READ_WORKINGDAYS'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['working-days']">
                  <mat-icon>
                    <fa-icon icon="calendar-alt" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Working Days' | translate }}
                    @if (arrowBooleans[13]) {
                      <p matLine [routerLink]="['working-days']" class="menu-explanation">
                        {{ 'labels.text.Working days and configure behaviour of payments' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[13]) {
                    <fa-icon (click)="arrowBooleansToggle(13)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[13]) {
                    <fa-icon (click)="arrowBooleansToggle(13)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #paymenttypes>
            <mat-list-item *LOSxHasPermission="'READ_PAYMENTTYPE'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['payment-types']">
                  <mat-icon matListIcon>
                    <fa-icon icon="dollar-sign" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Payment Type' | translate }}
                    @if (arrowBooleans[14]) {
                      <p matLine [routerLink]="['payment-types']" class="menu-explanation">
                        {{ 'labels.text.Manage payment types' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[14]) {
                    <fa-icon (click)="arrowBooleansToggle(14)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[14]) {
                    <fa-icon (click)="arrowBooleansToggle(14)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #smscampaigns>
            <mat-list-item *LOSxHasPermission="'VIEW_SMSCAMPAIGNS'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['sms-campaigns']">
                  <mat-icon matListIcon>
                    <fa-icon icon="envelope" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.SMS Campaigns' | translate }}
                    @if (arrowBooleans[15]) {
                      <p matLine [routerLink]="['sms-campaigns']" class="menu-explanation">
                        {{ 'labels.text.Define SMS Campaigns for Organization' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[15]) {
                    <fa-icon (click)="arrowBooleansToggle(15)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[15]) {
                    <fa-icon (click)="arrowBooleansToggle(15)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #adhocquery>
            <mat-list-item *LOSxHasPermission="'VIEW_ADHOC'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['adhoc-query']">
                  <mat-icon matListIcon>
                    <fa-icon icon="chevron-right" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.AdHocQuery' | translate }}
                    @if (arrowBooleans[16]) {
                      <p matLine [routerLink]="['adhoc-query']" class="menu-explanation">
                        {{ 'labels.text.Define AdHocQuery for Organization' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[16]) {
                    <fa-icon (click)="arrowBooleansToggle(16)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[16]) {
                    <fa-icon (click)="arrowBooleansToggle(16)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #bulkimport>
            <mat-list-item *LOSxHasPermission="'VIEW_BULKIMPORT'">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['bulk-import']">
                  <mat-icon matListIcon>
                    <fa-icon icon="upload" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Bulk Import' | translate }}
                    @if (arrowBooleans[17]) {
                      <p matLine [routerLink]="['bulk-import']" class="menu-explanation">
                        {{ 'labels.text.Bulk data import using excel spreadsheet templates' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[17]) {
                    <fa-icon (click)="arrowBooleansToggle(17)" icon="arrow-down" size="md"></fa-icon>
                  }
                  @if (arrowBooleans[17]) {
                    <fa-icon (click)="arrowBooleansToggle(17)" icon="arrow-up" size="md"></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>
        </mat-nav-list>
      </div>
    </div>
  </mat-card>
</div>

<ng-template #templateOffice let-popover="popover">
  <h2>{{ 'labels.heading.Manage Offices' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Manage Offices page allows you to create, edit' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepOffice()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepOffice()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateAddEditCurrency let-popover="popover">
  <h2>{{ 'labels.heading.Currency Configuration' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Define what currencies interactions within the LOS X system' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepAddEditCurrency()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepAddEditCurrency()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateHolidays let-popover="popover">
  <h2>{{ 'labels.heading.Manage Holidays' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Ability to manage holidays for individual offices' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepHolidays()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepHolidays()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateEmployee let-popover="popover">
  <h2>{{ 'labels.heading.Manage Employees' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.View, edit and delete employees of your organization' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepEmployee()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepEmployee()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateWorkingDays let-popover="popover">
  <h2>{{ 'labels.heading.Working Days' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Working days page allows you to define which days' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepWorkingDays()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepWorkingDays()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateManageFunds let-popover="popover">
  <h2>{{ 'labels.heading.Manage Funds' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.This allows you to manage funds associated with loans.' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepManageFunds()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepManageFunds()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>
